import { ServerSentEvent } from "./Types/ServerSentEvent"

const DEFAULT_EVENT_NAME = "message"

// Incremental parser for the text/event-stream format: feed it the decoded chunks as they arrive, it returns the
// events completed so far. Only "\n" and "\r\n" line endings are supported, which is what our backend (Ktor) emits.
// A block still open when the stream ends is never dispatched, as the spec requires.
export function createServerSentEventParser() {
  let pendingLine = ""
  let eventName = ""
  let dataLines: string[] = []

  function processLine(line: string, events: ServerSentEvent[]) {
    if (line === "") {
      // A block without data (a bare heartbeat, a lone "event:" line) carries nothing worth dispatching.
      if (dataLines.length > 0) {
        events.push({ event: eventName || DEFAULT_EVENT_NAME, data: dataLines.join("\n") })
      }
      eventName = ""
      dataLines = []
      return
    }
    if (line.startsWith(":")) {
      return
    }
    const colonIndex = line.indexOf(":")
    const field = colonIndex === -1 ? line : line.slice(0, colonIndex)
    const rawValue = colonIndex === -1 ? "" : line.slice(colonIndex + 1)
    const value = rawValue.startsWith(" ") ? rawValue.slice(1) : rawValue
    if (field === "event") {
      eventName = value
    } else if (field === "data") {
      dataLines.push(value)
    }
  }

  return {
    push(chunk: string): ServerSentEvent[] {
      const lines = (pendingLine + chunk).split("\n")
      // The last piece has no line ending yet: keep it until the next chunk completes it. A "\r" split from its
      // "\n" across two chunks stays on that piece and is stripped once the line is complete.
      pendingLine = lines.pop() ?? ""
      const events: ServerSentEvent[] = []
      for (const line of lines) {
        processLine(line.endsWith("\r") ? line.slice(0, -1) : line, events)
      }
      return events
    },
  }
}
